(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
  $(document).ready(function () {
    $('.article img').each(function () {
      var imageCaption = $(this).attr('alt')
      if (imageCaption != '') {
        $("<span class='img-caption'><em>" + imageCaption + '</em></span>').insertAfter(this)
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-image-with-text"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.video').each(function () {
      $(this).play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
    frenzyScriptReload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frenzy-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
    frenzyScriptReload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.video').each(function () {
      $(this).play();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
